"use client";
import React from "react";
import FilterPatientScript from "../../../global/view/filter-patient-scriptForm";
import styles from "../css/rewrite-script-patient-filter.module.css";

export default function RewriteScriptFilterPatient() {
  return (
    <FilterPatientScript
      hideNewScriptButton={true}
      hideMedicationHistoryButton={true}
      columnsToHide={["repeat", "paymentType", "followUp"]}
      filterRowClassName={styles.rightShiftedRow}
      hideOtc={true}
      actionNavigatePath="/customer/dispensary/amend-script"
      actionNavigateResolver={(row) =>
        row.paymentType === "Cash"
          ? `/customer/dispensary/amend-script/${row.scriptNo}`
          : `/customer/dispensary/medical-aid-ammend-filter/${row.scriptNo}`
      }
    />
  );
}